import { Paper } from '@material-ui/core';
import FormTextBox from '../../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox';
import { FormsContainer } from '../ordersSetting/Forms/FormsContainer'
import ListLoading from '../util/Loading';
import { IGeneralForms } from './GeneralForms';
import { useGeneralForm } from './useGeneralForm';


export  function GroupLogoSettings( { dispatch } : IGeneralForms) {
  const { formData, onSubmit, t } = useGeneralForm(dispatch);


  if(!formData){
    return <Paper style={{padding:"10rem 0"}}>
      <ListLoading/>
    </Paper>
  }

  return (
    <FormsContainer profileForms={[
      {
        formRows: [{
          label: "groups.form.logo_group",
          keyName: "logo_group",
          Component: FormTextBox,
          registerOptions:
          {
              required: true,
              validate: (value: string) => validateGroupLogo(value,t)
          },
          gridColumnOptions: { formCol: 12 }
      }],
        title: "groups.form.GroupSettingsTitle",
        formKey: "GroupLogoSettings",
        formButtonText:"groups.buttons.submit"
      }
    ]}
      onFormSubmit={onSubmit}
      settings={{...formData , logo_group: formData.logo_group}}
      formKey={"Group-Logo-Form"}
    />
  )
}

function validateGroupLogo(value: string , t:(key:string) => string) { 
  return value.trim().length>0 || t('groups.form.error.logo');
}